import * as $ from 'jquery';
import { apiBaseUrlUser } from "../../../constants/url.constant";
import { DefaultService } from "../../common/services/DefaultService";

export default class HomeService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/home`;

    public RouteGetContacts = () => `${this.baseUrl}/getContacts`;
    public getContacts(): JQueryPromise<any> {
        return $.ajax(this.RouteGetContacts(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetBanners = () => `${this.baseUrl}/getBanners`;
    public getBanners(): JQueryPromise<any> {
        return $.ajax(this.RouteGetBanners(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetHomeLinks = (isMobile: boolean) => `/${this.baseUrl}/getHomeLinks?isMobile=${isMobile}`;
    public getHomeLinks(isMobile: boolean): JQueryPromise<any> {
        return $.ajax(apiBaseUrlUser + this.RouteGetHomeLinks(isMobile), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}